import {ContextCodes} from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import {useHistory, useLocation} from "react-router-dom";
import {AuthXService} from "@brg/auth";
import {AppTester} from "../../../../supporting";
import {useContextsTabs} from "../../../hooks/useContextsTabs";
import {useMemo} from "react";
import { useTranslation } from "react-i18next";

export const useGetHseSpaceContext = () => {
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const { context: currentContext } = useContextsTabs();

    const {
        REACT_APP_URL_HSEDESIGN_COM,
        REACT_APP_URL_HSE_SPACE,
        REACT_APP_URL_HSEDESIGN_RU,
        REACT_APP_URL_HSEDESIGN_LMS_COM,
        REACT_APP_URL_HSEDESIGN_LMS,
        REACT_APP_URL_HSEDESIGN_PRO_COM,
        REACT_APP_URL_HSEDESIGN_PRO_RU,
    } = process.env;
    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const history = useHistory()
    const baseURL = REACT_APP_URL_HSE_SPACE;

    const links = useMemo(() => ([
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-architect'),
            content: t('nav.hsespace_nav.architect'),
            linkTo: `${baseURL}/architect`,
            action: () => {
                window.open(baseURL + '/architect' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-biology'),
            content: t('nav.hsespace_nav.biology'),
            linkTo: `${baseURL}/biology`,
            action: () => {
                window.open(baseURL + '/biology' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-oriental'),
            content: t('nav.hsespace_nav.oriental'),
            linkTo: `${baseURL}/oriental`,
            action: () => {
                window.open(baseURL + '/oriental' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-geography'),
            content: t('nav.hsespace_nav.geography'),
            linkTo: `${baseURL}/geography`,
            action: () => {
                window.open(baseURL + '/geography' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseBooks,
            active: pathname === 'hsedesign.ru',
            content: t('nav.hsespace_nav.design'),
            action: () => {
                window.location.href = `${process.env.REACT_APP_URL_HSEDESIGN_RU ?? 'https://hsedesign.ru'}${suffix}`;
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-history'),
            content: t('nav.hsespace_nav.history'),
            linkTo: `${baseURL}/history`,
            action: () => {
                window.open(baseURL + '/history' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-arthistory'),
            content: t('nav.hsespace_nav.arthistory'),
            linkTo: `${baseURL}/arthistory`,
            action: () => {
                window.open(baseURL + '/arthistory' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-cinema'),
            content: t('nav.hsespace_nav.cinema'),
            linkTo: `${baseURL}/cinema`,
            action: () => {
                window.open(baseURL + '/cinema' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        //  {
        //     id: ContextCodes.hseDesignMain,
        //     active: AppTester.isContext('s-cognitive'),
        //     content: t('nav.hsespace_nav.art'),
        //     linkTo: `${baseURL}/cognitive`,
        //     action: () => {
        //         window.open(baseURL + '/cognitive' + suffix, '_self')
        //     },
        //     target: '_self',
        //     level: 1,
        //     hasChildren: true,
        //     hasCornerArrow: false,
        //     hidden: false,
        // },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-culturology'),
            content: t('nav.hsespace_nav.culturology'),
            linkTo: `${baseURL}/culturology`,
            action: () => {
                window.open(baseURL + '/culturology' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-mathematics'),
            content: t('nav.hsespace_nav.mathematics'),
            linkTo: `${baseURL}/mathematics`,
            action: () => {
                window.open(baseURL + '/mathematics' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-media'),
            content: t('nav.hsespace_nav.media'),
            linkTo: `${baseURL}/media`,
            action: () => {
                window.open(baseURL + '/media' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-fashion'),
            content: t('nav.hsespace_nav.fashion'),
            linkTo: `${baseURL}/fashion`,
            action: () => {
                window.location.href = `${process.env.REACT_APP_URL_HSEDESIGN_RU ?? 'https://hsedesign.ru'}?tab=fashion`;
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-music'),
            content: t('nav.hsespace_nav.music'),
            linkTo: `${baseURL}/music`,
            action: () => {
                window.open(baseURL + '/music' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-production'),
            content: t('nav.hsespace_nav.production'),
            linkTo: `${baseURL}/production`,
            action: () => {
                window.open(baseURL + '/production' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-psychology'),
            content: t('nav.hsespace_nav.psychology'),
            linkTo: `${baseURL}/psychology`,
            action: () => {
                window.open(baseURL + '/psychology' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-physics'),
            content: t('nav.hsespace_nav.physics'),
            linkTo: `${baseURL}/physics`,
            action: () => {
                window.open(baseURL + '/physics' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-chemistry'),
            content: t('nav.hsespace_nav.chemistry'),
            linkTo: `${baseURL}/chemistry`,
            action: () => {
                window.open(baseURL + '/chemistry' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-economy'),
            content: t('nav.hsespace_nav.economy'),
            linkTo: `${baseURL}/economy`,
            action: () => {
                window.open(baseURL + '/economy' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-public-administration'),
            content: t('nav.hsespace_nav.public-administration'),
            linkTo: `${baseURL}/public-administration`,
            action: () => {
                window.open(baseURL + '/public-administration' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        // {
        //     id: ContextCodes.hseDesignMain,
        //     active: AppTester.isContext('pro'),
        //     content: t('nav.hsespace_nav.pro'),
        //     linkTo: `${baseURL}/pro`,
        //     action: () => {
        //         window.open(baseURL + '/pro' + suffix, '_self')
        //     },
        //     target: '_self',
        //     level: 1,
        //     hasChildren: true,
        //     hasCornerArrow: false,
        //     hidden: false,
        // }
        // {
        //     id: ContextCodes.hseDesignMain,
        //     active: AppTester.isContext('pro'),
        //     content: t('nav.hsespace_nav.pro'),
        //     linkTo: `${baseURL}/pro`,
        //     action: () => {
        //         window.open(baseURL + '/pro' + suffix, '_self')
        //     },
        //     target: '_self',
        //     level: 1,
        //     hasChildren: true,
        //     hasCornerArrow: false,
        //     hidden: false,
        // }
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-urban-development'),
            content: t('nav.hsespace_nav.urban-development'),
            linkTo: `${baseURL}/urban-development`,
            action: () => {
                window.open(baseURL + '/urban-development' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-computer-science-and-engineering'),
            content: t('nav.hsespace_nav.computer-science-and-engineering'),
            linkTo: `${baseURL}/computer-science-and-engineering`,
            action: () => {
                window.open(baseURL + '/computer-science-and-engineering' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-international-relations'),
            content: t('nav.hsespace_nav.international-relations'),
            linkTo: `${baseURL}/international-relations`,
            action: () => {
                window.open(baseURL + '/international-relations' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-management'),
            content: t('nav.hsespace_nav.management'),
            linkTo: `${baseURL}/management`,
            action: () => {
                window.open(baseURL + '/management' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-political-science'),
            content: t('nav.hsespace_nav.political-science'),
            linkTo: `${baseURL}/political-science`,
            action: () => {
                window.open(baseURL + '/political-science' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-advertising-and-pr'),
            content: t('nav.hsespace_nav.advertising-and-pr'),
            linkTo: `${baseURL}/advertising-and-pr`,
            action: () => {
                window.open(baseURL + '/advertising-and-pr' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-sociology'),
            content: t('nav.hsespace_nav.sociology'),
            linkTo: `${baseURL}/sociology`,
            action: () => {
                window.open(baseURL + '/sociology' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-philology'),
            content: t('nav.hsespace_nav.philology'),
            linkTo: `${baseURL}/philology`,
            action: () => {
                window.open(baseURL + '/philology' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-philosophy'),
            content: t('nav.hsespace_nav.philosophy'),
            linkTo: `${baseURL}/philosophy`,
            action: () => {
                window.open(baseURL + '/philosophy' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-jurisprudence'),
            content: t('nav.hsespace_nav.jurisprudence'),
            linkTo: `${baseURL}/jurisprudence`,
            action: () => {
                window.open(baseURL + '/jurisprudence' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
    ]), [REACT_APP_URL_HSEDESIGN_COM, REACT_APP_URL_HSEDESIGN_LMS, REACT_APP_URL_HSEDESIGN_LMS_COM, REACT_APP_URL_HSEDESIGN_PRO_COM,
        REACT_APP_URL_HSEDESIGN_PRO_RU, REACT_APP_URL_HSEDESIGN_RU, currentContext, history, suffix, t])

    return {
        links,
        modalSettings: {
            titleColor: '#151514',
            title: 'hsespace'
        }
    }
}import {ContextCodes} from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import {useHistory, useLocation} from "react-router-dom";
import {AuthXService} from "@brg/auth";
import {AppTester} from "../../../../supporting";
import {useContextsTabs} from "../../../hooks/useContextsTabs";
import {useMemo} from "react";
import { useTranslation } from "react-i18next";

export const useGetHseSpaceContext = () => {
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const { context: currentContext } = useContextsTabs();

    const {
        REACT_APP_URL_HSEDESIGN_COM,
        REACT_APP_URL_HSE_SPACE,
        REACT_APP_URL_HSEDESIGN_RU,
        REACT_APP_URL_HSEDESIGN_LMS_COM,
        REACT_APP_URL_HSEDESIGN_LMS,
        REACT_APP_URL_HSEDESIGN_PRO_COM,
        REACT_APP_URL_HSEDESIGN_PRO_RU,
    } = process.env;
    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const history = useHistory()
    const baseURL = REACT_APP_URL_HSE_SPACE;

    const links = useMemo(() => ([
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-architect'),
            content: t('nav.hsespace_nav.architect'),
            linkTo: `${baseURL}/architect`,
            action: () => {
                window.open(baseURL + '/architect' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-biology'),
            content: t('nav.hsespace_nav.biology'),
            linkTo: `${baseURL}/biology`,
            action: () => {
                window.open(baseURL + '/biology' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-oriental'),
            content: t('nav.hsespace_nav.oriental'),
            linkTo: `${baseURL}/oriental`,
            action: () => {
                window.open(baseURL + '/oriental' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-geography'),
            content: t('nav.hsespace_nav.geography'),
            linkTo: `${baseURL}/geography`,
            action: () => {
                window.open(baseURL + '/geography' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseBooks,
            active: pathname === 'hsedesign.ru',
            content: t('nav.hsespace_nav.design'),
            action: () => {
                window.location.href = `${process.env.REACT_APP_URL_HSEDESIGN_RU ?? 'https://hsedesign.ru'}${suffix}`;
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-history'),
            content: t('nav.hsespace_nav.history'),
            linkTo: `${baseURL}/history`,
            action: () => {
                window.open(baseURL + '/history' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-arthistory'),
            content: t('nav.hsespace_nav.arthistory'),
            linkTo: `${baseURL}/arthistory`,
            action: () => {
                window.open(baseURL + '/arthistory' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-cinema'),
            content: t('nav.hsespace_nav.cinema'),
            linkTo: `${baseURL}/cinema`,
            action: () => {
                window.open(baseURL + '/cinema' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        //  {
        //     id: ContextCodes.hseDesignMain,
        //     active: AppTester.isContext('s-cognitive'),
        //     content: t('nav.hsespace_nav.art'),
        //     linkTo: `${baseURL}/cognitive`,
        //     action: () => {
        //         window.open(baseURL + '/cognitive' + suffix, '_self')
        //     },
        //     target: '_self',
        //     level: 1,
        //     hasChildren: true,
        //     hasCornerArrow: false,
        //     hidden: false,
        // },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-culturology'),
            content: t('nav.hsespace_nav.culturology'),
            linkTo: `${baseURL}/culturology`,
            action: () => {
                window.open(baseURL + '/culturology' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-mathematics'),
            content: t('nav.hsespace_nav.mathematics'),
            linkTo: `${baseURL}/mathematics`,
            action: () => {
                window.open(baseURL + '/mathematics' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-media'),
            content: t('nav.hsespace_nav.media'),
            linkTo: `${baseURL}/media`,
            action: () => {
                window.open(baseURL + '/media' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-fashion'),
            content: t('nav.hsespace_nav.fashion'),
            linkTo: `${baseURL}/fashion`,
            action: () => {
                window.location.href = `${process.env.REACT_APP_URL_HSEDESIGN_RU ?? 'https://hsedesign.ru'}?tab=fashion`;
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-music'),
            content: t('nav.hsespace_nav.music'),
            linkTo: `${baseURL}/music`,
            action: () => {
                window.open(baseURL + '/music' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-production'),
            content: t('nav.hsespace_nav.production'),
            linkTo: `${baseURL}/production`,
            action: () => {
                window.open(baseURL + '/production' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-psychology'),
            content: t('nav.hsespace_nav.psychology'),
            linkTo: `${baseURL}/psychology`,
            action: () => {
                window.open(baseURL + '/psychology' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-physics'),
            content: t('nav.hsespace_nav.physics'),
            linkTo: `${baseURL}/physics`,
            action: () => {
                window.open(baseURL + '/physics' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-chemistry'),
            content: t('nav.hsespace_nav.chemistry'),
            linkTo: `${baseURL}/chemistry`,
            action: () => {
                window.open(baseURL + '/chemistry' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-economy'),
            content: t('nav.hsespace_nav.economy'),
            linkTo: `${baseURL}/economy`,
            action: () => {
                window.open(baseURL + '/economy' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
         {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-public-administration'),
            content: t('nav.hsespace_nav.public-administration'),
            linkTo: `${baseURL}/public-administration`,
            action: () => {
                window.open(baseURL + '/public-administration' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        // {
        //     id: ContextCodes.hseDesignMain,
        //     active: AppTester.isContext('pro'),
        //     content: t('nav.hsespace_nav.pro'),
        //     linkTo: `${baseURL}/pro`,
        //     action: () => {
        //         window.open(baseURL + '/pro' + suffix, '_self')
        //     },
        //     target: '_self',
        //     level: 1,
        //     hasChildren: true,
        //     hasCornerArrow: false,
        //     hidden: false,
        // }
        // {
        //     id: ContextCodes.hseDesignMain,
        //     active: AppTester.isContext('pro'),
        //     content: t('nav.hsespace_nav.pro'),
        //     linkTo: `${baseURL}/pro`,
        //     action: () => {
        //         window.open(baseURL + '/pro' + suffix, '_self')
        //     },
        //     target: '_self',
        //     level: 1,
        //     hasChildren: true,
        //     hasCornerArrow: false,
        //     hidden: false,
        // }
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-urban-development'),
            content: t('nav.hsespace_nav.urban-development'),
            linkTo: `${baseURL}/urban-development`,
            action: () => {
                window.open(baseURL + '/urban-development' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-computer-science-and-engineering'),
            content: t('nav.hsespace_nav.computer-science-and-engineering'),
            linkTo: `${baseURL}/computer-science-and-engineering`,
            action: () => {
                window.open(baseURL + '/computer-science-and-engineering' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-international-relations'),
            content: t('nav.hsespace_nav.international-relations'),
            linkTo: `${baseURL}/international-relations`,
            action: () => {
                window.open(baseURL + '/international-relations' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-management'),
            content: t('nav.hsespace_nav.management'),
            linkTo: `${baseURL}/management`,
            action: () => {
                window.open(baseURL + '/management' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-political-science'),
            content: t('nav.hsespace_nav.political-science'),
            linkTo: `${baseURL}/political-science`,
            action: () => {
                window.open(baseURL + '/political-science' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-advertising-and-pr'),
            content: t('nav.hsespace_nav.advertising-and-pr'),
            linkTo: `${baseURL}/advertising-and-pr`,
            action: () => {
                window.open(baseURL + '/advertising-and-pr' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-sociology'),
            content: t('nav.hsespace_nav.sociology'),
            linkTo: `${baseURL}/sociology`,
            action: () => {
                window.open(baseURL + '/sociology' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-philology'),
            content: t('nav.hsespace_nav.philology'),
            linkTo: `${baseURL}/philology`,
            action: () => {
                window.open(baseURL + '/philology' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-philosophy'),
            content: t('nav.hsespace_nav.philosophy'),
            linkTo: `${baseURL}/philosophy`,
            action: () => {
                window.open(baseURL + '/philosophy' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: AppTester.isContext('s-jurisprudence'),
            content: t('nav.hsespace_nav.jurisprudence'),
            linkTo: `${baseURL}/jurisprudence`,
            action: () => {
                window.open(baseURL + '/jurisprudence' + suffix, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
            hidden: false,
        },
    ]), [REACT_APP_URL_HSEDESIGN_COM, REACT_APP_URL_HSEDESIGN_LMS, REACT_APP_URL_HSEDESIGN_LMS_COM, REACT_APP_URL_HSEDESIGN_PRO_COM,
        REACT_APP_URL_HSEDESIGN_PRO_RU, REACT_APP_URL_HSEDESIGN_RU, currentContext, history, suffix, t])

    return {
        links,
        modalSettings: {
            titleColor: '#151514',
            title: 'hsespace'
        }
    }
}